module.exports = __webpack_public_path__ + "static/media/Thailand-desktop.c69a4998.jpg";